import { Close } from '@mui/icons-material';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, IconButton } from '@mui/material';
import { Component } from 'react';

export default class AddUserToExclusionModal extends Component
{
    render()
    {
        const { action, onCancel, setEmail, email } = this.props;

        return (
            <Dialog
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                open={true}
                onClose={onCancel}
                fullWidth
            >
                <DialogTitle id="delete-excl-user" sx={{ m: 0, p: 2 }}>
                    Add user to exclusion list
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={onCancel}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: 'black.900'
                    }}
                >
                    <Close />
                </IconButton>
                <DialogContent style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
                    <DialogContentText id="alert-dialog-description" style={{ marginTop: -20, fontSize: 12 }}>
                        Enter the email of the borrower you want to add to the exclusion list
                    </DialogContentText>

                    <DialogContentText>
                        <div className="">
                            <label>Email</label>
                            <input
                                disabled={false}
                                type="email"
                                className="form-control"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                name="email"
                            />
                        </div>
                    </DialogContentText>
                </DialogContent>

                <Divider />

                <DialogActions style={{ justifyContent: 'space-between', padding: 20 }}>

                    <Button onClick={onCancel} variant="outlined" color="warning">
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={action}
                        color="primary"
                        autoFocus
                        disabled={!email}
                    >
                        Add
                    </Button>
                </DialogActions>

            </Dialog>
        )
    }
}
